export function calculateTotalQuestions(formDefinition: PolicyFormDefinition): number {
  return formDefinition.sections.reduce((total, section) => {
    return (
      total +
      section.subsections.reduce((subTotal, subsection) => {
        return (
          subTotal +
          subsection.questionGroups.reduce((qTotal, group) => {
            return qTotal + group.questions.length;
          }, 0)
        );
      }, 0)
    );
  }, 0);
}

/**
 * Centralized function to check if a value is considered "empty"
 * Handles various data types including arrays and objects
 */
export function isEmptyValue(value: PolicyFormSubmissionDataValue | undefined | null): boolean {
  // Handle null/undefined
  if (value === undefined || value === null) return true;

  // Handle empty string
  if (value === '') return true;

  // Handle arrays - empty array is considered empty
  if (Array.isArray(value)) return value.length === 0;

  // Handle objects (for table data) - empty object is considered empty
  if (typeof value === 'object' && value !== null) {
    return Object.keys(value).length === 0;
  }

  // All other values (including false, 0) are considered non-empty
  return false;
}

/**
 * Validates if a string is a valid ComparisonOperator
 */
export function isValidComparisonOperator(operator: string): boolean {
  const validOperators = [
    'equals',
    'notEquals',
    'contains',
    'notContains',
    'empty',
    'notEmpty',
    'in',
    'notIn',
    'greaterThan',
    'greaterThanOrEqual',
    'lessThan',
    'lessThanOrEqual',
  ];

  return validOperators.includes(operator);
}

/**
 * Validates if a string is a valid logical operator
 */
export function isValidLogicalOperator(operator: string): operator is 'and' | 'or' {
  return operator === 'and' || operator === 'or';
}
